/* istanbul ignore file */
export const enum RecurringStatus {
  Default = "default",
  OneOff = "oneOff",
  DetachedOccurrence = "detachedOccurrence",
  Series = "series",
  DetachedSeries = "detachedSeries"
}
